import { ItemList } from "../../types/content-search";

export const SRC_SHOW_LIMIT = 5;

export const areEqual = (array1: string[], array2: string[]) => {
    if (array1.length === array2.length) {
        return array1.every((element, index) => {
            if (element === array2[index]) {
                return true;
            }

            return false;
        });
    }

    return false;
};

export const sortItems = (items: ItemList, selectedItems: string[], filterLimit: number) => {
    const renderedSelection = items.slice(0, filterLimit);

    const sortBySelection = [...items].sort((item1, item2) => {
        const item1Selected = selectedItems.includes(item1.value);
        const item1IsRendered = !!renderedSelection.find((it) => it.value === item1.value);

        const item2Selected = selectedItems.includes(item2.value);
        const item2IsRendered = !!renderedSelection.find((it) => it.value === item2.value);

        // Selected items are bumped if not rendered
        if (item1Selected && !item1IsRendered) return -1;
        if (item2Selected && !item2IsRendered) return 1;

        // Selected items are bumped up against not selected items
        if (item1Selected && !item2Selected) return -1;
        if (item2Selected && !item1Selected) return 1;

        // Otherwise leave the order as is
        return 0;
    });

    return sortBySelection;
};

export const getFilterLimit = (selectedLength: number) => {
    if (selectedLength > SRC_SHOW_LIMIT) return selectedLength;
    return SRC_SHOW_LIMIT;
};

export const handleFormChange =
    (handler: (e: React.ChangeEvent<HTMLInputElement>) => void, setData: (data: string[]) => void, data: string[], isMobile: boolean) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked, name } = e.target;

        if (!isMobile) {
            handler(e);
            return;
        }

        if (checked) {
            setData([...data, name]);
        } else {
            setData(data.filter((v) => v !== name));
        }
    };
